import { Box } from "@mui/material";
import AboutMe from "../AboutMe/AboutMe";
import Banner from "../Banner/Banner";

const Home = () => {
  return (
    <Box>
      <Banner></Banner>
      <AboutMe></AboutMe>
    </Box>
  );
};

export default Home;
